import React from "react";

import CategoryRecommendedHeader from "../category-recommended-header/categoryRecommendedHeader";
import CategoryRecommendedBody from "../category-recommended-body/categoryRecommendedBody";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { findRel } from "../../../shared/utils/stringUtilities";

import "./categoryRecommended.scss";
interface CategoryRecommendedInterface {
  isAnyActive: boolean;
  recommended: ReferenciaDestacados;
}

interface ReferenciaDestacados {
  redireccionBoton: string;
  nombreCategoria: string;
  descripcion: { json: any };
  tipoDestacado: string;
  tituloPrincipal: string;
  referenciaDestacados: ReferenciaDestacadosBody;
  imagenPrincipal: {
    title: string;
    file: {
      url: string;
      fileName: string;
    };
    fluid: any;
  };
  tituloBoton: string;
}

interface ReferenciaDestacadosBody {
  tituloGeneral: string;
  tipoCuerpoDestacado: string;
  referenciaPlantillaContenido: ReferenciaContenido;
}

const CategoryRecommended = (props: CategoryRecommendedInterface) => {
  const { isAnyActive, recommended } = props;

  const renderHeader = () => {
    return (
      <CategoryRecommendedHeader
        type={recommended.tipoDestacado}
        category={recommended.nombreCategoria}
        description={recommended.descripcion}
        title={recommended.tituloPrincipal}
        image={recommended.imagenPrincipal}
        tituloBoton={recommended.tituloBoton}
      />
    );
  };

  const renderBody = () => {
    return (
      <CategoryRecommendedBody
        iconType={recommended.tipoDestacado}
        type={recommended.referenciaDestacados.tipoCuerpoDestacado}
        sectionTitle={recommended.referenciaDestacados.tituloGeneral}
        content={recommended.referenciaDestacados.referenciaPlantillaContenido}
      />
    );
  };

  return (
    <>
      {!isAnyActive && (
        <div className="m-category-recommended">
          <div className="m-category-recommended__background" />
          <span className="m-category-recommended__title">Te recomendamos</span>
          <a href={recommended.redireccionBoton} rel={findRel(recommended.redireccionBoton)}>
          {renderHeader()}
          </a>
          <a 
            href={recommended.referenciaDestacados.referenciaPlantillaContenido[0].redireccionBoton}
            rel={findRel(recommended.redireccionBoton)}
          >
            {recommended.referenciaDestacados && renderBody()}
          </a>
        </div>
      )}
    </>
  );
};

export default CategoryRecommended;
